import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

// Translations
const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      events: 'Events',
      videos: 'Videos',
      contact: 'Contact'
    },
    // Home page
    home: {
      learnMore: 'Learn More',
      welcome: 'Welcome',
      aboutUs: 'About Us',
      aboutDesc: 'We are a community of believers passionate about worship, discipleship, and service.',
      ourServices: 'Our Services',
      sundayWorship: 'Sunday Worship',
      sundayWorshipDesc: 'Join us every Sunday for a powerful time of worship and the Word.',
      bibleStudy: 'Bible Study',
      bibleStudyDesc: 'Grow deeper in your faith through our midweek Bible study sessions.',
      youthMinistry: 'Youth Ministry',
      youthMinistryDesc: 'A vibrant community for young people to grow and connect.',
      visitUs: 'Visit Us',
      getDirections: 'Get Directions',
      connectWithUs: 'Connect With Us',
      followSocial: 'Follow us on social media to stay updated with our latest news and events.',
      footerRights: 'All rights reserved.',
      language: 'Language'
    },
    // About page
    about: {
      title: 'About Us',
      subtitle: 'House Of Worship Davao is a vibrant community of believers dedicated to spreading God\'s love and grace throughout Davao City and beyond.',
      ourValues: 'Our Core Values',
      ourStory: 'Our Story',
      ourLeadership: 'Our Leadership',
      faith: 'Faith',
      faithDesc: 'We believe in the power of faith and trust in God\'s plan for our lives.',
      love: 'Love',
      loveDesc: 'Love is at the center of everything we do, reflecting Christ\'s love to all.',
      community: 'Community',
      communityDesc: 'We are stronger together, building meaningful relationships in Christ.',
      service: 'Service',
      serviceDesc: 'Serving others is our calling, making a difference in our community.',
      excellence: 'Excellence',
      excellenceDesc: 'We strive for excellence in worship, ministry, and all we do.',
      worship: 'Worship',
      worshipDesc: 'Passionate worship that honors God and transforms lives.'
    },
    // Events page
    events: {
      title: 'Events & Services',
      subtitle: 'Join us for worship, fellowship, and community. There\'s something for everyone at House of Worship Davao!',
      upcomingEvents: 'Upcoming Events',
      weeklySchedule: 'Weekly Schedule',
      joinUs: 'Join Us This Week',
      joinUsDesc: 'We would love to have you worship with us! Whether you\'re new to faith or looking for a church home, you\'re welcome here.',
      getDirections: 'Get Directions'
    },
    // Videos page
    videos: {
      title: 'Videos',
      subtitle: 'Watch our worship services, Bible studies, and special events',
      subscribe: 'Subscribe to Our Channel',
      subscribeDesc: 'Never miss a sermon or event. Subscribe for weekly updates!',
      subscribeBtn: 'Subscribe Now',
      addVideoId: 'Add YouTube Video ID'
    },
    // Contact page
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'d love to hear from you! Whether you have questions, prayer requests, or just want to connect, reach out to us.',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      serviceHours: 'Service Hours',
      sendMessage: 'Send us a Message',
      yourName: 'Your Name',
      emailAddress: 'Email Address',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      findUs: 'Find Us',
      connectWithUs: 'Connect With Us',
      thankYou: 'Thank you for your message! We will get back to you soon.'
    },
    // Language selector
    langSelector: {
      chooseLanguage: 'Choose Your Language',
      continue: 'Continue'
    }
  },
  fil: {
    // Navigation
    nav: {
      home: 'Tahanan',
      about: 'Tungkol',
      events: 'Mga Kaganapan',
      videos: 'Mga Video',
      contact: 'Makipag-ugnayan'
    },
    // Home page
    home: {
      learnMore: 'Matuto Pa',
      welcome: 'Maligayang Pagdating',
      aboutUs: 'Tungkol Sa Amin',
      aboutDesc: 'Kami ay isang komunidad ng mga mananampalataya na masigasig sa pagsamba, pagtuturo, at paglilingkod.',
      ourServices: 'Aming Mga Serbisyo',
      sundayWorship: 'Pagsamba sa Linggo',
      sundayWorshipDesc: 'Samahan kami tuwing Linggo para sa isang makapangyarihang panahon ng pagsamba at Salita.',
      bibleStudy: 'Pag-aaral ng Bibliya',
      bibleStudyDesc: 'Lumago nang mas malalim sa iyong pananampalataya sa pamamagitan ng aming pag-aaral ng Bibliya.',
      youthMinistry: 'Ministeryo ng Kabataan',
      youthMinistryDesc: 'Isang masigla na komunidad para sa mga kabataan na lumago at makipag-ugnayan.',
      visitUs: 'Bisitahin Kami',
      getDirections: 'Kumuha ng Direksyon',
      connectWithUs: 'Kumonekta Sa Amin',
      followSocial: 'Sundan kami sa social media upang manatiling updated sa aming mga balita at kaganapan.',
      footerRights: 'Lahat ng karapatan ay nakalaan.',
      language: 'Wika'
    },
    // About page
    about: {
      title: 'Tungkol Sa Amin',
      subtitle: 'Ang House Of Worship Davao ay isang masigla na komunidad ng mga mananampalataya na nakatuon sa pagpapalaganap ng pag-ibig at biyaya ng Diyos sa buong Davao City at higit pa.',
      ourValues: 'Aming Mga Pangunahing Halaga',
      ourStory: 'Aming Kasaysayan',
      ourLeadership: 'Aming Pamunuan',
      faith: 'Pananampalataya',
      faithDesc: 'Naniniwala kami sa kapangyarihan ng pananampalataya at tiwala sa plano ng Diyos para sa ating buhay.',
      love: 'Pag-ibig',
      loveDesc: 'Ang pag-ibig ay nasa sentro ng lahat ng aming ginagawa, na nagpapakita ng pag-ibig ni Kristo sa lahat.',
      community: 'Komunidad',
      communityDesc: 'Mas malakas tayo kapag magkasama, nagtatayo ng makabuluhang relasyon kay Kristo.',
      service: 'Serbisyo',
      serviceDesc: 'Ang paglilingkod sa iba ay aming tawag, gumagawa ng pagkakaiba sa aming komunidad.',
      excellence: 'Kahusayan',
      excellenceDesc: 'Nagsisikap kami para sa kahusayan sa pagsamba, ministeryo, at lahat ng aming ginagawa.',
      worship: 'Pagsamba',
      worshipDesc: 'Masigasig na pagsamba na nagpaparangal sa Diyos at nagbabago ng buhay.'
    },
    // Events page
    events: {
      title: 'Mga Kaganapan at Serbisyo',
      subtitle: 'Samahan kami sa pagsamba, pakikisama, at komunidad. May para sa lahat sa House of Worship Davao!',
      upcomingEvents: 'Mga Paparating na Kaganapan',
      weeklySchedule: 'Lingguhang Iskedyul',
      joinUs: 'Samahan Kami Ngayong Linggo',
      joinUsDesc: 'Gusto naming sumamba ka kasama namin! Kung bago ka sa pananampalataya o naghahanap ng simbahang tahanan, malugod kang tinatanggap dito.',
      getDirections: 'Kumuha ng Direksyon'
    },
    // Videos page
    videos: {
      title: 'Mga Video',
      subtitle: 'Panoorin ang aming mga serbisyo sa pagsamba, pag-aaral ng Bibliya, at mga espesyal na kaganapan',
      subscribe: 'Mag-subscribe sa Aming Channel',
      subscribeDesc: 'Huwag palampasin ang anumang sermon o kaganapan. Mag-subscribe para sa lingguhang update!',
      subscribeBtn: 'Mag-subscribe Ngayon',
      addVideoId: 'Magdagdag ng YouTube Video ID'
    },
    // Contact page
    contact: {
      title: 'Makipag-ugnayan',
      subtitle: 'Gusto naming marinig mula sa iyo! Kung mayroon kang mga tanong, kahilingan sa panalangin, o gusto lang makipag-ugnayan, kontakin kami.',
      address: 'Address',
      phone: 'Telepono',
      email: 'Email',
      serviceHours: 'Oras ng Serbisyo',
      sendMessage: 'Magpadala ng Mensahe',
      yourName: 'Iyong Pangalan',
      emailAddress: 'Email Address',
      subject: 'Paksa',
      message: 'Mensahe',
      send: 'Ipadala ang Mensahe',
      findUs: 'Hanapin Kami',
      connectWithUs: 'Kumonekta Sa Amin',
      thankYou: 'Salamat sa iyong mensahe! Babalikan ka namin sa lalong madaling panahon.'
    },
    // Language selector
    langSelector: {
      chooseLanguage: 'Piliin ang Iyong Wika',
      continue: 'Magpatuloy'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || null; // null means not selected yet
  });

  const [showSelector, setShowSelector] = useState(!localStorage.getItem('language'));

  useEffect(() => {
    if (language) {
      localStorage.setItem('language', language);
    }
  }, [language]);

  const selectLanguage = (lang) => {
    setLanguage(lang);
    setShowSelector(false);
  };

  const t = translations[language] || translations.en;

  return (
    <LanguageContext.Provider value={{
      language: language || 'en',
      setLanguage: selectLanguage,
      showSelector,
      setShowSelector,
      t,
      translations
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
